import React from 'react';
import { Checkbox } from '@mantine/core';
import { FieldProps } from '../form-helpers';

export type FormFieldCheckboxProps = Omit<FieldProps, 'value' | 'onChange'> & {
    value: boolean;
    onChange: (value: boolean) => void;
};

function FormFieldCheckbox({ label, value, onChange, disabled }: FormFieldCheckboxProps) {
    return (
        <Checkbox
            label={label}
            checked={!!value}
            onChange={(e) => onChange(e.currentTarget.checked)}
            disabled={disabled}
            mt="sm"
        />
    );
}

export default React.memo(FormFieldCheckbox);
